/**
 *
 * AgentCard
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Avatar from 'react-avatar';
import ReactHtmlParser from 'react-html-parser';
import linkedinIcon from 'assets/icons/linkedin.svg';
import shortMomentString from 'utils/shortMomentString';
import Moment from 'react-moment';
import InsentAvatar from 'ui/components/Avatar';
import {ReactComponent as AttachmentIcon} from "assets/icons/attachFileHome.svg";

import { MOMENT_TIME_LIMIT } from 'common/constants'
const CardWrapper = styled.div`
  display: flex;
  padding: 10px;
  cursor: pointer;
  align-items: center;
  max-height: 4.31rem;
  background-color: ${p => p.theme.palette.white};
  box-shadow: 0 17px 15px 0 rgba(80, 80, 80, 0.1);
  border-radius: 15px;
  margin-bottom: 5px;
  transition: 0.4s all;
  &:hover {
    box-shadow: 0 17px 15px 0 rgba(80, 80, 80, 0.2);
  }
`;

const AvatarWrapper = styled.div`
  position: relative;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  margin-left: ${p => p.marginLeft || '0'};
  margin-right: ${p => p.marginRight || '0'};
  z-index: ${p => p.zIndex || '1'};
`;


export const AgentSenderMessageWrapper = styled.div`
  margin-left: 0.69rem;
  width: 100%;
`;

export const AgentName = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  max-width: 80%;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const AgentLinkedinIcon = styled.img`
  margin-left: 0.25rem;
`;

export const AgentMessage = styled.div`
  cursor: pointer;
  font-size: 12px;
  color: ${p => p.theme.palette.blue4};
  line-height: 14px;
  opacity: 0.8;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const AgentMessageDiv = styled.div`
display: flex;
`


export const AgentSubtitle = styled.div`
  cursor: pointer;
  font-size: 12px;
  color: ${p => p.theme.palette.blue4};
  line-height: 14px;
  opacity: 0.8;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const AgentTitle = styled.div`
  font-size: 10px;
  opacity: 0.6;
  margin-bottom: 2px;
  color: #2F3C4E;
`;

export const AgentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AgentTime = styled.div`
  text-align: right;
  font-size: 9px;
  opacity: 0.5;
`;

export const AgentCard = ({
  members,
  name,
  linkedinUrl,
  message,
  time,
  online,
  userSettingBot,
  userSettingColor,
  onClick,
  isAttachment
}) => {
  return (
    <CardWrapper id="insent-agent-card-card-wrapper" data-testid="insent-test-card-wrapper" onClick={onClick}>
      {members && members.length > 0 ? (
        members.map((member, memberIndex) => (
          <React.Fragment key={memberIndex}>
            {memberIndex < 2 &&
              <InsentAvatar
                data-testid="insent-test-insent-avatar"
                bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}
                size={member.isBot ? "40" : "50"}
                img={member.isBot ? (userSettingBot.overrideLogo ? userSettingBot.overrideLogo : member.img) : member.img}
                name={member.name}
                isBot={member.isBot}
                zIndex={memberIndex}
                marginLeft={memberIndex === 0 ? '0' : `-${30 + (memberIndex - 1) * 5}px`}
              />
              }
          </React.Fragment>
        ))
      ) : (
        <InsentAvatar
          id="insent-agent-card-insent-avatar"
          data-testid="insent-test-insent-avatar"
          bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}
          size="40px"
          img={(userSettingBot?(userSettingBot.overrideLogo ? userSettingBot.overrideLogo : userSettingBot.img):null)}
          name={(userSettingBot && userSettingBot.name)}
          isBot={true}
        />
      )}
      <AgentSenderMessageWrapper id={"insent-agent-card-agent-sender-message-wrapper"}>
        <AgentHeader id="insent-agent-card-agent-sender">
          <AgentName id="insent-agent-card-agent-name">
            {name}
            {members && members.length === 1 && members[0].linkedinUrl && (
              <a href={members[0].linkedinUrl} target="_blank" rel="noopener noreferrer">
                <AgentLinkedinIcon src={linkedinIcon} alt="linkedin" height={16} width={16} />
              </a>
            )}
          </AgentName>
          {time && time > 0 && (
            <AgentTime>
              <Moment ago interval={10000} fromNow unix filter={shortMomentString}>
                {time > MOMENT_TIME_LIMIT
                    ? time / 1000
                    : time
                }
              </Moment>
            </AgentTime>
          )}
        </AgentHeader>
        {members && members.length === 1 && members[0].title && <AgentTitle>{members[0].title || ''}</AgentTitle>}
        {members && members.length === 1 && members[0].title ? (
          <AgentSubtitle>{ReactHtmlParser(message)}</AgentSubtitle>
        ) : (
            <AgentMessageDiv>
              {isAttachment && <AttachmentIcon/>}
              <AgentMessage>{ReactHtmlParser(message)}</AgentMessage>
            </AgentMessageDiv>
        )}
      </AgentSenderMessageWrapper>
    </CardWrapper>
  );
};

AgentCard.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  linkedinUrl: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  data: PropTypes.string,
  online: PropTypes.bool,
};

export default AgentCard;
